import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IonImg,IonIcon, IonMenuToggle } from '@ionic/angular/standalone';
import { MenuHelper } from 'src/app/menuHelper';
import { BaseHelper } from 'src/app/baseHelper';
import { GlobalProvider } from 'src/services/global';
import { MerchantAPI } from 'src/services/merchant_api.service';

import { filter } from 'rxjs/operators';

import { addIcons } from 'ionicons';
import {
  person,
  homeOutline,
  starOutline,
  swapHorizontalOutline,
  receiptOutline,
  qrCodeOutline,
  business,
  businessOutline
} from 'ionicons/icons';

addIcons({
  person,
  homeOutline,
  starOutline,
  swapHorizontalOutline,
  receiptOutline,
  qrCodeOutline,
  businessOutline
});

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [CommonModule, IonImg,IonIcon, IonMenuToggle],
})
export class SidebarComponent implements OnInit {
  activeRoute: string = '';
  walletPoints: number = 0;


  //  Parent / Child Route Mapping
  PARENT_MAP: Record<string, string[]> = {
    '/dashboard': ['/dashboard'],
    '/coupon': ['/coupon', '/coupon-detail'],
    '/banner': ['/banner', '/banner-detail'],
    '/campaign': ['/campaign', '/campaign-detail'],
    '/gps': ['/gps', '/gps-detail'],
    '/business-listing': ['/business-listing','/business'],
    '/customer': ['/customer','/customer-detail'],
    '/membership': ['/membership', '/membership-detail'],
    '/category': ['/category', '/category-detail'],
    // '/wallet': ['/wallet'],
    '/transaction-listing': ['/transaction-listing', '/wallet'],
    '/user-profile-listing': [ '/user-profile-details'],
    '/accessRole-list': ['/accessRole/detail'], 
    '/business-manage-listing': ['/business-manage-detail'],
    '/interest-listing': ['/interest-details'],
    '/invoice-listing': ['/invoice-listing', '/invoice-details'],
  };
  

  constructor(
    private router: Router,
    public menuHelper: MenuHelper,
    private b: BaseHelper,
    public g: GlobalProvider,
    private api: MerchantAPI
  ) {
    this.activeRoute = this.router.url;
  }

  // ngOnInit() {

  //   this.walletAmount();


  //   // Set active route on initial load
  //   this.activeRoute = this.router.url;

  //   // Update on navigation
  //   this.router.events
  //     .pipe(filter((event) => event instanceof NavigationEnd))
  //     .subscribe((event: NavigationEnd) => {
  //       this.activeRoute = event.urlAfterRedirects;
  //     });
  // }
  ngOnInit() {
  this.walletAmount();

  
  this.activeRoute = this.router.url.split('?')[0];

  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      
      this.activeRoute = event.urlAfterRedirects.split('?')[0];
    });
}

  async navigateTo(route: string) {
    this.activeRoute = route;
    await this.b.menuClose();
    this.router.navigate([route]);
  }

  // getNavItemClass(route: string): string {
  //   if (this.activeRoute === route) {
  //     return 'text-white bg-[#E91447] font-medium';
  //   }
  //   return 'text-gray-700 hover:bg-gray-50';
  // }

  isParentActive(parent: string): boolean {
    const prefixes = this.PARENT_MAP[parent] || [];

    // -----------------------------------------
    //  Check PARENT_MAP first (optional)
    // -----------------------------------------
    for (const p of prefixes) {
      if (this.activeRoute === p) return true;
      if (this.activeRoute.startsWith(p + '/')) return true;
    }

    // -----------------------------------------
    //  Default exact + segment match
    // -----------------------------------------
    if (this.activeRoute === parent) return true;
    if (this.activeRoute.startsWith(parent + '/')) return true;

    // -----------------------------------------
    //  Special case: dynamic "/id/business"
    // -----------------------------------------
    // if (parent === '/business-listing') {
    //   const parts = this.activeRoute.split('/');

    //   // ['', '5', 'business']
    //   if (parts.length >= 3 && parts[2] === 'business') {
    //     return true;
    //   }
    // }

    return false;
  }

  getNavItemClass(route: string): string {
    return this.isParentActive(route)
      ? 'text-white bg-[#E91447] font-medium' // ACTIVE
      : 'text-gray-700 hover:bg-gray-50'; // DEFAULT
  }
  // getNavItemClass(route: string): string {
  //   if (this.activeRoute === route) {
  //     return 'text-white bg-[#E91447] font-medium'; // ✅ SELECTED STYLE
  //   }
  //   return 'text-gray-700 hover:bg-gray-50'; // 🔘 DEFAULT STYLE
  // }

  async walletAmount() {
    (await this.api.merchantWalletBalance()).subscribe((result: any) => {
      const r: any = result;
      console.log('Wallet', r);

      if (!r.ok) return;

      // Adjust based on your actual API response shape
      this.walletPoints = r.data?.points || 0;
    });
  }

  async goToWallet() {
    await this.b.menuClose();
    this.b.navigate('/wallet');
  }

  async logout() {
    await this.b.clearJws();
    await this.b.setStorage('companyToken', null);
    await this.b.menuClose();
    await this.b.navigateRoot('/login');
  }
}
